import { LOCAL_STORAGE_KEYS } from './local-storage-keys.js'
import { SESSION_STORAGE_KEYS } from './session-storage-keys.js'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('storage')

const STORAGE = {
  SESSION: 'session',
  LOCAL: 'local',
}

const storageTypes = {
  [STORAGE.SESSION]: sessionStorage,
  [STORAGE.LOCAL]: localStorage,
}

const storageKeys = {
  [STORAGE.SESSION]: SESSION_STORAGE_KEYS,
  [STORAGE.LOCAL]: LOCAL_STORAGE_KEYS,
}

export function useStorage (storageType = STORAGE.LOCAL) {
  if (!Object.values(STORAGE).includes(storageType)) {
    logger.error('Invalid storageType')
    return
  }

  const storage = storageTypes[storageType]
  const KEYS = storageKeys[storageType]

  const keyExist = (key) => {
    return (Object.values(KEYS).includes(key))
      ? true
      : (logger.warn('useStorage: expected key does not exist'), false)
  }

  const setItem = (key, value) => {
    if (keyExist(key)) {
      storage.setItem(key, JSON.stringify(value))
    }
  }

  const getItem = (key) => {
    if (!keyExist(key)) return null

    try {
      return JSON.parse(storage.getItem(key))
    } catch (error) {
      logger.error(`Error parsing storage key "${key}":`, error)
      return null
    }
  }

  const removeItem = (key) => {
    if (keyExist(key)) {
      storage.removeItem(key)
    }
  }

  const clear = () => {
    storage.clear()
  }

  return { setItem, getItem, removeItem, clear, KEYS }
}
